var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m.1 0 53.1 40Zm0 40L53.2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf142b",
    d: "M0 0v2.4L23.4 20 0 37.6V40h3.7l23-17.5 23 17.5h3.6v-2.4L30 20 53.3 2.4V0h-3.6l-23 17.5L3.7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf142b",
    stroke: "maroon",
    strokeMiterlimit: 140.8,
    strokeWidth: 0.1,
    d: "M30.4 5.4c.9 3.7.4 8.2-3.7 10.7-4.1-2.5-4.6-7-3.7-10.7 1-.9 5.3-1.4 7.4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "M24.6 7.6h-.2l-.1-.2H24l-.2-.1h.2l-.2-.1-.2-.1h.2l-.2-.1-.2-.1.2-.1h-.2l-.2-.1.2-.1v-.1h-.3v-.2l.1-.2.1-.3q.2 0 .3.2v-.1a.1.1 0 0 1 .2 0v.5l.5.4.2.2h.3v.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#377bc8",
    d: "M23.7 5.8V6h.1v-.1zm-.4 0V6h.1v-.1m-.1.4H23l.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "M26.5 7.8H26a.1.1 0 0 0 0 .2h.2l-.1.2.2.1v.1h.3l.1-.1.2-.2v.2l.2-.1v-.1.1h.2V8l.1.1h.1v-.2l.3-.1-.1-.2q-.2-.1 0-.2v-.1l.3-.2V7h-1.2l.3.4v.2l-.2.2-.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "m27.8 7-.1.3h-.2v-.1h-.6l.3-.3h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "m28.6 5.8.4-.1.1-.1q0 .3-.3.4h-.9q.2.1 0 .2v-.1h-1.4v.2h.2q.3.2.7.1l.8-.1.7-.2h.8q.6 0 .6.4 0 .3-.6.4h-1.2l.1.2.2.1h1v.1h.3l.1.1h-.1v.1l.2.1h-.1l.1.1V8h.1-.2v.2l.1.2-.2.1h-.3v-.1h-.3a.1.1 0 0 1 0-.2h.2l.1-.2-.3-.2-.1-.2-.4.1h-.6q-.5-.2-1-.7h-.3l-1.2.7h-.6V8H25v.2l-.3.1V8v.2h-.3l-.2.2v-.2l-.1.1-.2.1v-.2h-.1l-.2.2h-.2v-.2q-.3 0-.3-.2t.2-.2a.1.1 0 0 1 .1-.2h.1l.1.2h.2l.6-.2h.4v-.8h1.5l1-.1h1.8q.6 0 1-.2l-.1-.2h-.4v.1l.1.1h-.2v-.2l-.1.1v.1h-.2v-.2l-.1.1v.2l-.1-.1-.1-.2-.7.1-.8.2h-1l-.2-.3V6l.5-.3h.7q.4-.1.8 0l.3-.1v-.2l.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.6 5.8.4-.1.1-.1q0 .3-.3.4h-.9q.2.1 0 .2v-.1h-1.4v.2h.2q.3.2.7.1l.8-.1.7-.2h.8q.6 0 .6.4 0 .3-.6.4h-1.2l.1.2.2.1h1v.1h.3l.1.1h-.1v.1l.2.1h-.1l.1.1V8h.1-.2v.2l.1.2-.2.1h-.3v-.1h-.3a.1.1 0 0 1 0-.2h.2l.1-.2-.3-.2-.1-.2-.4.1h-.6q-.5-.2-1-.7h-.3l-1.2.7h-.6V8H25v.2l-.3.1V8v.2h-.3l-.2.2v-.2l-.1.1-.2.1v-.2h-.1l-.2.2h-.2v-.2q-.3 0-.3-.2t.2-.2a.1.1 0 0 1 .1-.2h.1l.1.2h.2l.6-.2h.4v-.8h1.5l1-.1h1.8q.6 0 1-.2l-.1-.2h-.4v.1l.1.1h-.2v-.2l-.1.1v.1h-.2v-.2l-.1.1v.2l-.1-.1-.1-.2-.7.1-.8.2-1-.1-.2-.2V6l.5-.3h.7q.4-.1.8 0l.3-.1v-.2l.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "M25.6 6.9h.2v-.5h.1V6h-.1l-.2-.2v-.1l-.2-.1-.2.1H25V6l-.2-.2V6l-.1.1v.4h-.2q0 .2.2.2-.4.4-.1.7v-.1l.1.2.1.2h.3l.2-.2v.1q.4-.1.3-.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#504416",
    d: "M25 6.5v.3h.1l.3.1v-.3h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25 6.5v.2zm.3.1v.2zm0 .1V7zm-.3-.6a.1.1 0 0 0 .2 0zm.5.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1b948",
    d: "M25 6v.2h.2V6zm0 0 .1.1v.1H25zm.5.2a.1.1 0 0 0 0 .2h.1v-.2zm0 0h.1v.1a.1.1 0 0 1-.2 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "m25 6 .1.1h.2-.1zm.6.1h-.2v.1h.3m-.7.7q.2.5.4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#806600",
    d: "M25 6.8h-.1V7a.2.2 0 0 0 .5 0v-.1zm0 0 .3.1v.2H25l-.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#377bc8",
    d: "M25.1 6.5v.6l.2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "M25.5 5.7h-.2l-.1.1-.2.1h.3zl.1.2V6h.2v-.2h-.1zm-.6.5.1.1v.2h.2v.1h.2l.1-.1h.1v-.1h-.2v.1h-.2a.1.1 0 0 1-.2 0 .1.1 0 0 1 0-.2zm-.1 0-.2.2v.2q-.3.4 0 .7v-.1l.1.2.1.2h.3l.2-.2v.1q.4-.1.3-.6h.2v-.4l-.1.1v.2l-.2-.1v.6-.1l-.1-.3v.3l-.2.2V7l-.1.3H25l-.1.1v-.1l-.2-.2.2-.3-.2.1-.1.2v-.4l.3-.3h-.3l.1-.1zm.4 0v.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6 6.9h.2v-.5h.1V6h-.1l-.2-.2-.2-.2-.2.1H25V6l-.2-.2V6l-.1.1v.4h-.2q0 .2.2.2-.4.4-.1.7v-.1l.1.2.1.2h.3l.2-.2v.1q.4-.1.3-.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#806600",
    d: "M24.8 5.8v.3V6m.2.2.1.1h.2l-.1.1v.2h.2v-.2h.2l.1.1-.2-.1-.1-.1v.2l-.1.1H25v-.1l.2-.1V6H25m0 .1a.1.1 0 0 0-.1.2v.1l.1.1h.2v.1h.3l.1-.1v-.1h-.1v.1l-.1.1h-.1v-.1H25zm1 0h-.2v.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2200",
    d: "M25 6h.1m.5.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#377bc8",
    d: "m23.4 7.6-.3.1h.2m2.8.2H26zm-3 .1-.2.2h.2zm3 .2-.1.2h.2zm-2.9.2v.2l.1-.1v-.1m6.2 0-.1.2h.2zm-3 0v.2h.1v-.2m3.7 0v.4zm-.4.1v.3l.1-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "M24.6 10.6h-.2l-.1-.2h-.4l.2-.2h-.4l.2-.2h-.3l.1-.2h-.1l-.2-.1h.2v-.1l-.3-.1v-.2q-.1-.1.1-.1v-.3l.3.1h.2v.4l.5.4.2.3h.3v.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#377bc8",
    d: "M23.7 8.9h.2zm-.3 0h-.1l.1.2h.1V9zm-.1.3-.2.1h.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "M26.4 10.8H26v.1l.1.1v.2h.2v.2h.2l.1-.1.2-.2v.2l.1-.1V11l.1.2.2-.1v-.2.2l.2-.1v-.1l.3-.1-.2-.2v-.3l.3-.1v-.3h-.6l-.5.1.3.3v.1l.1.1q-.1.3-.2.2l-.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "M27.6 10.1v.3a.1.1 0 0 1-.2 0v-.2h-.5l.2-.3h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "m28.5 8.9.3-.1v-.1l-.2.3h-.8v.3l-.1-.2-.3.1h-1v.1l.2.1H28l.7-.2h.7q.7 0 .6.3-.1.4-.5.4-.7.2-1.2 0l.1.2.2.2h.8v-.1h.1l.1.1h.2l.1.1-.1.1h.1l.1.1h-.1l.1.1.1.1H30l.2.1v.2H30v.3l-.2.1h-.2v-.1h-.3a.1.1 0 0 1 0-.2h.2l.2-.2-.3-.2-.2-.2-.4.1h-.4c-.4 0-.7-.5-1-.6H27c-.4 0-.8.5-1.2.6h-.5l-.1.2H25l-.1.2-.2.1V11v.2h-.2v-.1l-.1.1-.2.1v-.2l-.1.2h-.6q-.2 0 0-.2l-.3-.1q0-.2.2-.2a.1.1 0 0 1 0-.2h.2v.2h.3l.5-.2h.4v-.8h4.1q.5 0 .9-.2v-.2h-.4v.1l-.2-.1v.2H29v-.2l-.1.1v.1h-.1l-.1-.2-.7.1-.8.1h-.9l-.2-.2V9l.5-.2H28l.3-.1v-.2l.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "m28.5 8.9.3-.1v-.1l-.2.3h-.8v.3l-.1-.2-.3.1h-1v.1l.2.1H28l.7-.2h.7q.7 0 .6.3-.1.4-.5.4-.7.2-1.2 0l.1.2.2.2h.8v-.1h.1l.1.1h.2l.1.1-.1.1h.1l.1.1h-.1l.1.1.1.1H30l.2.1v.2H30v.3l-.2.1h-.2v-.1h-.3a.1.1 0 0 1 0-.2h.2l.2-.2-.3-.2-.2-.2-.4.1h-.4c-.4 0-.7-.5-1-.6H27c-.4 0-.8.5-1.2.6h-.5l-.1.2H25l-.1.2-.2.1V11v.2h-.2v-.1l-.1.1-.2.1v-.2l-.1.2h-.6q-.2 0 0-.2l-.3-.1q0-.2.2-.2a.1.1 0 0 1 0-.2h.2v.2h.3l.5-.2h.4v-.8h4.1q.5 0 .9-.2v-.2h-.4v.2h-.1v-.2h-.1v.2H29v-.2l-.1.1v.1h-.1l-.1-.2-.7.1-.8.1h-.9l-.2-.2V9l.5-.2H28l.3-.1v-.2l.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "M25.6 9.9h.2v-.1l-.1-.2v-.1h.2v-.3h-.2V9h-.1a.1.1 0 0 0-.2-.1h-.1l-.1.1h-.4q-.2.2 0 .2v.3h-.2v.2q-.3.3 0 .7l.1.1.1.2h.3l.2-.2v.1q.4 0 .3-.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#504416",
    d: "m25 9.5-.1.3.2.1h.2l.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.3 9.6v.2zm-.3.1v.2zm.3.1-.1.2zm-.3-.7v.2a.1.1 0 0 0 .2 0zm.5.2h-.1v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1b948",
    d: "M25 9.1v.2a.1.1 0 0 0 .2 0v-.1zm0 0h.1v.1zm.5.2h-.1v.1zm0 0h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "M25 9h.2zm.6.2h-.2zm-.7.6c-.1.3.3.4.4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#806600",
    d: "M24.9 9.8v.2a.2.2 0 0 0 .4 0zm0 0 .4.1v.2H25V10q-.2 0 0-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#377bc8",
    d: "M25 9.6v.6l.3-.5-.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "m25.4 8.8-.1.1H25h.1V9h.2q0-.2.1-.1l.1.2h.1l.1.1V9h-.1zm-.5.4.1.2v.2h.6v-.1h-.2l-.1.1H25v-.2q-.3 0-.2-.2m-.1 0-.2.3v.1q-.3.3 0 .7l.1.1.1.2h.3l.2-.2v.1q.4 0 .3-.6h.2v-.1l-.1-.2v.2h-.2v.5l-.1.1V10v.2l-.2.2V10l-.1.3h-.2v.1-.1l-.2-.2.1-.3-.1.1-.1.2v-.4l.3-.2h-.2zm.4.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6 9.9h.2v-.1l-.1-.2v-.1h.2v-.3h-.2V9h-.1l-.2-.2-.2.1h-.4q-.2.2 0 .2v.3h-.2v.2q-.3.3 0 .7l.1.1.1.2h.3l.2-.2v.1q.4 0 .3-.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#806600",
    d: "M24.8 9v.2zm.2.1h.3v.2H25v.1h.1v.1h.2v-.3l.2.1h-.1l-.1-.1v.2h-.2zm-.1.1a.1.1 0 0 0 0 .2l.1.2h.5a.1.1 0 0 0 .1-.2v.1h-.1v.1H25v-.2h-.1zm1 0h-.1l-.1.2h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#377bc8",
    d: "m23.4 10.6-.2.1zm2.7.2H26zm-2.9.1-.1.2h.1l.1-.1m3 .2-.2.2h.2zm-2.8.1v.3zm5.9 0-.2.3.2-.1zm-2.8.2-.1.2zm3.4 0v.2zm-.3 0v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "M25.3 13.2H25v-.1h-.4l.2-.2h-.3v-.1l-.2-.1h.2-.2l-.1-.2h.1q0-.2-.2-.2V12q0-.2.2-.2h.3v.4l.6.5h.2v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#377bc8",
    d: "M24.6 11.8v.2h.1zm-.3 0v.2zm-.1.3H24l.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "M26.5 13.4h-.1a.1.1 0 0 0-.2 0v.1h.2l-.1.2h.1l.1.2h.2v-.1l.2-.1h.1v-.1l.1.1h.1v-.2.2l.2-.1v-.2h.2l-.1-.1V13l.2-.1v-.2h-.9l.3.3H27v.2l-.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "M27.3 12.9H27l-.2-.1h-.2l.2-.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "m27.8 11.9.2-.1.1-.1-.2.3h-.5v.2-.1h-1v.1l.2.1h.9l.5-.2h.5q.5 0 .3.3 0 .3-.3.3h-.8l.1.1.1.2h.5v-.1h.2v.1h.1l.1.1h-.1.1v.2l.1.1v.5h-.6a.1.1 0 0 1 0-.2h.2v-.1l-.1-.2-.1-.2-.3.1h-.3l-.7-.5-.8.5h-.4v.2h-.2v.1l-.1.1v-.1h-.1l-.1.2v-.2.2H25v-.1l-.2.2v-.2l-.2.1q-.2 0-.1-.1a.1.1 0 0 1-.2-.1l.1-.2q0-.2.1-.1h.1l.2.1.3-.2h.3v-.6H28q.4 0 .6-.2l-.1-.2h-.2v.2h.1-.1v-.2l-.1.2h-.1v-.1.2l-.2-.1v-.2l-.5.2h-1.1l-.1-.2v-.1l.3-.2.4-.1h.7v-.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "m28.1 11.7-.1.2h-.7v.1h-.6l.1.2h.3l.1-.1h.2V12h.6v-.2zm.4.4-.1.2v-.2l-.2.3v-.2l-.1.2v-.2H28l-1 .2h-.6l-.1-.2v.2h.9l.8-.2v.2h.1v-.1l.1.1h.1v-.2.2h.2v-.2h.2v.2q.2-.2-.2-.3m.3.2v.2q-.6.4-1.1 0H27l-.7.2h-.9.2l-.2.4v-.2.2l-.2.1-.2.1-.2.1h-.2v-.1.1l.2.1.3-.2h.3l.2-.1h.2l.1-.2v-.2h.2l.7-.2h.5l.3.2.3.3h.2l.1-.1h.3l.2.1-.1.1h.1v.2h.1v.3-.1h.1v-.2h-.1v-.2h-.1l.1-.1h-.2v-.2h-.7l-.2-.2h.7q.2 0 .4-.3zm-1.8.4h-.2l-.5.3-.2.2h-.4v.2h-.2v.2l-.2-.2v.2l-.2-.1v.2l-.1-.1-.1.2v-.2h-.1l-.2.2v-.2h-.2v-.1h.1v-.2.1l-.2.1a.1.1 0 0 0 .2.2v.2h.1q0-.2.2-.2v.2l.1-.1.1-.1v.1h.1v-.2.2l.2-.1v-.1.1h.2v-.2h.2v-.2h.4zl.7.5h.6l.3.3h-.1l-.1.1v.1h.1v.1h.2a.1.1 0 0 0 .2 0v-.2.2h-.1l-.1-.1v.1h-.1v-.1h-.1v-.1l.1-.1-.2-.2-.1-.2h-.7l-.4-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.8 11.9.2-.1.1-.1-.2.3h-.5v.2-.1h-1v.1l.2.1h.9l.5-.2h.5q.5 0 .3.3 0 .3-.3.3h-.8l.1.1.1.2h.5v-.1h.2v.1h.1l.1.1h-.1.1v.2l.1.1v.5h-.6a.1.1 0 0 1 0-.2h.2v-.1l-.1-.2-.1-.2-.3.1h-.3l-.7-.5-.8.5h-.4v.2h-.2v.1l-.1.1v-.1h-.1l-.1.2v-.2.2H25v-.1l-.2.2v-.2l-.2.1q-.2 0-.1-.1a.1.1 0 0 1-.2-.1l.1-.2q0-.2.1-.1h.1l.2.1.3-.2h.3v-.6H28q.4 0 .6-.2l-.1-.2h-.2v.2h.1-.1v-.2l-.1.2h-.1v-.1.2l-.2-.1v-.2l-.5.2h-1.1l-.1-.2v-.1l.3-.2.4-.1h.7v-.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "M25.9 12.7h.1v-.4h.1V12h-.2v-.2h-.1l-.1-.1h-.3v.1h-.2v.4H25v.2q-.3.2 0 .5l.1.3h.2v-.1l.2-.1q.4 0 .3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#504416",
    d: "m25.4 12.4-.1.2h.2l.1.1.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.6 12.4v.2zm-.2-.3h.1zm.4 0h-.1v.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1b948",
    d: "M25.4 12v.2h.1V12zm0 0h.1zm.4.2h-.1v.1zm0 0h-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "M25.4 12h.2zm.5.1h-.2zh.1m-.6.5q.1.4.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#806600",
    d: "M25.3 12.6v.2h.3v-.1zm0 0 .3.1v.1h-.2q-.2 0 0-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#377bc8",
    d: "m25.5 12.4-.1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "M25.7 11.8h-.3v.1zv.2h.1v-.2zm-.4.3v.3h.2l.1.1h.1v-.1h.1-.4v-.1zm0 0-.2.2H25l.1.2q-.3.2 0 .5l.1.3h.2v-.1l.2-.1q.4 0 .3-.4h.1v-.3l-.1.1v.1h-.1v.4h-.1v-.3.2l-.2.2v-.2.2h-.2l-.1-.2v-.2l-.1.2v-.2q0-.2.2-.3H25v-.1zm.3.1h-.1v.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9 12.7h.1v-.4h.1V12h-.2v-.2l-.1-.1-.3.1h-.3v.4H25v.2q-.3.2 0 .5l.1.2v.1h.2v-.1l.2-.1q.4 0 .3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#806600",
    d: "M25.4 12h.2zv.3h.2v-.2h.2-.2V12v.2h-.2zm-.1.1v.3h.2l.1.1h.1l.2-.1v-.1h-.1v.1a.1.1 0 0 1-.2 0h-.2v-.1h-.1zm.8 0H26v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#377bc8",
    d: "M24.5 13.3h-.1zm1.8 0-.2.1zm-2 .2h.1v-.1m.2.2v.2zm3.9 0-.1.2h.1zm-1.8.1-.1.2h.1zm2.2 0v.3zm-.2 0v.3-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    stroke: "#806600",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M31.6 1.8v-.2l-.6.2-.2.3v.3l-.2-.2h-.1l-.3.1-.1.3v.3l-.2.2h.4l.2-.3h0l.1.1v.3h-.3 0v.2h0q0 0 0 0l-.2.2h0-.6v-.1l-.2-.1-.2-.4.5-.5v0q0 0 0 0v-.1h-.1v-.2q0 0 0 0l-.4-.1h0l-.5.3h0v.1l.3.5-.2.2q-.3.3-.8.3t-.9-.2V3h.2v-.1l-.1-.1h0v-.5l.1.1.1.3.2.2h.3V2l-.3-.2h-.3v-.3l-.1-.4-.3-.3-.3.3-.2.4v.3H26l-.2.2v1h.2l.2-.2v-.3h.2q0 0 0 0l.1.4h0l-.2.1.2.1h0l-.1.3q-.5.3-.9.2t-.7-.3l-.2-.2.3-.5-.2-.3-.3-.1h0l-.4.1v.2h-.1q0 0 0 0v.1l.4.5-.2.4-.1.1q0 0 0 0l-.3.1q0 0 0 0h-.3 0l-.3-.1h0l.1-.2h0l-.2-.1h0l-.2-.3v-.1a.1.1 0 0 1 .2 0l.1.2.2.1h.3l-.2-.2v-.3l-.2-.3-.2-.1h-.2l-.1.2V2l-.3-.3-.6-.2v.1h0l.8 1.6h-.1l-.1.2h.3l.2.5h-.2V4q0 0 0 0v.1h.2v.1h0v.2l-.1.2.1.2.1.2h0v.1h0v.1q0 0 0 0v.1h1l.4-.1h5.5l.6.1h0v-.1q0 0 0 0h0V5h0v-.2l.3-.2-.1-.2v-.2h0q0 0 0 0l.1-.2q0 0 0 0h-.2l.2-.6h.4l-.2-.2h0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJe);
export default __webpack_public_path__ + "static/media/je.ae9578ad227b66ad78c70643fd684b9a.svg";
export { ForwardRef as ReactComponent };